import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const ToxicologyReliableDrugTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4'>
            <div className=''>
                <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2'>
                    Reliable Drug Testing Services
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className=''>
                <text className='fs-ss-18 text-ss-black text-montserrat fw-600' style={{ fontStyle:'italic'}}>
                    Quick Turnaround & Uncompromising Quality 
                </text>
            </div>

            <div className='py-3'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    When you need a drug test near you, our conveniently located facility in Chicago provides easy access to our comprehensive drug testing services. With our quick drug tests, you can receive timely results, enabling prompt decision-making and ensuring the safety and well-being of individuals. 
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    United Lab Care takes pride in being one of Chicago’s leading Toxicology and Drug testing labs. Our advanced laboratory facilities and experienced professionals allow us to offer a wide range of toxicology testing services. We employ in vitro and in vivo testing methods to accurately assess substances’ safety and efficacy. With our expertise, you can have confidence in the reliability of our results. 
                </text>
            </div>

            <div className='pt-md-5 pt-4'>
                <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2' >
                    Pre Work Drug Testing Services
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-md-4'>
                <text className='fs-ss-18 text-ss-black text-montserrat fw-600' style={{ fontStyle:'italic'}}>
                    Fast, Accurate, and Confidential
                </text>
            </div>

            <div className='py-3 pb-md-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    We understand the need for fast drug testing, and our services are designed to meet tight deadlines. Our rapid drug tests provide quick and reliable results without compromising accuracy, ensuring you promptly receive the information you need. 
                </text>
            </div>

            <div className=''>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Regarding pre-work drug testing services, United Lab Care is your trusted partner. We provide comprehensive and reliable testing for drugs, chemicals, and environmental toxins. Our commitment to accuracy and efficiency sets us apart, making us the preferred choice for all blood and urine drug testing needs. 
                </text>
            </div>

            <div className='flex-center pt-4'>
                <Button className='btn-ss-secondary rounded30 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                <Link to='/toxicology-test-appointment' className='text-montserrat text-white fw-600 fs-ss-18' style={{ padding:'12px 14px', textDecoration:'none'}}>
                        Schedule Your Test
                    </Link>
                </Button>
            </div>


        </div>
    </div>
  )
}

export default ToxicologyReliableDrugTesting